import React, { useState } from 'react'
import HeaderItem from './header-item'
import { Link } from 'gatsby'

import FeatherImage from '../images/featherImage'
import styles from './Header.module.css'
import logo from './logo.png'

const headerPages = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'About',
    path: '/about',
  },
  // {
  //   name: 'Events',
  //   path: '/events',
  // },
  // {
  //   name: 'Blog',
  //   path: '/blog',
  // },
  {
    name: 'Sponsors',
    path: '/sponsors',
  },
  {
    name: 'Contact',
    path: '/contact',
  },
]

const Header = () => {
  // eslint-disable-next-line

  return (
    <nav className={styles.nav}>
      <div className={styles.container}>
        <div className={styles.innerContainer}>
          <header className={styles.title}>
            <Link to="/">Mayurpankh Events</Link>
            <FeatherImage alt="" className={styles.featherImage} />
          </header>

          <ul className={styles.pageList}>
            {headerPages.map(page => (
              <HeaderItem key={page.name} {...page} />
            ))}
          </ul>
        </div>
      </div>
    </nav>
  )
}

export default Header
